export default {
  menu: 'Announcements',
  title: 'Announcements',

  general: {
    labels: {
      priority: 'priority',
      type: 'subject',
      subject: 'subject',
      content: 'Text',
      bySystem: 'By system'
    },

    eventTypes: {
      all: 'All',
      update: 'System Update',
      activity: 'Activity',
      message: 'message',
      warning: 'warning'
    },

    priority: {
      all: 'All',
      veryLow: 'Very little',
      low: 'low',
      medium: 'medium',
      high: 'many',
      veryHigh: 'Too much'
    },

    validators: {
      subject: 'Subject not entered correctly',
      content: 'Content not entered correctly'
    },

    notifications: {
      insert: {
        success: 'Message sent successfully',
        error: 'Message sent failed'
      },

      parseError: {
        type: 'Type not selected',
        priority: 'Priority not selected'
      }
    },

    confirmations: {
      seenAll: {
        title: 'Seen all notification confirmation',
        body: 'You have {count} unread notifications, Are you sure about mark them as read?'
      }
    }
  },

  list: {
    table: {
      header: {
        rowNumber: 'Row',
        sender: 'Sender',
        subject: 'Subject',
        content: 'Content',
        type: 'Type',
        priority: 'Priority',
        sendDate: 'Send Date'
      }
    }
  },

  insert: {
    title: 'Send New Announcements'
  },

  event: {
    labels: {
      understand: 'I realized',
      checkController: 'Check in controller'
    }
  }
}
